// components/Toolbar/tools/SelectTool.js
import React, { useState } from 'react';
import Button from '../Toolbar/Button';
import { connect } from 'react-redux';
import OptionsPanel from '../OptionsPanel/OptionsPanel';
import styles from './Color.scss';
import { colorOptions } from './colorOptions';
import {
  setToolbarOptionsPanel,
  updateColor,
} from '../../../../redux/actions/fabric_overlay';
import { colorObjectStyle } from '../../helpers/fabricHelpers';
import { __ } from '../../../../core/utils';

const Color = ({
  fabric_overlay: { color, toolbarOptionsPanel, fabricOverlay },
}) => {
  const isOptionsOpen = toolbarOptionsPanel === 'color';

  const applyColorToActiveObject = (colorHex) => {
    const canvas = fabricOverlay.fabricCanvas();
    if (!canvas) return;

    const obj = canvas.getActiveObject();
    if (!obj) return;

    colorObjectStyle(obj, colorHex);
    canvas.requestRenderAll();
  };

  const toggleOptions = () => {
    setToolbarOptionsPanel(isOptionsOpen ? '' : 'color');
  };

  const handleColorSelect = (colorKey) => {
    const findColor = colorOptions.find((opt) => opt.key === colorKey);
    if (!findColor) return;

    updateColor(findColor);
    setToolbarOptionsPanel(isOptionsOpen ? '' : 'color');
    applyColorToActiveObject(findColor.hex);
  };

  return (
    <div className={styles.wrapper} id='wizard'>
      <Button
        id={color?.key}
        label={__('canvas.toolbar.color.' + color?.key)}
        icon={color?.icon}
        onClick={toggleOptions}
        extraClass={isOptionsOpen ? ['withBadge'] : ['withBadge', 'roundedUp']}
      />

      {isOptionsOpen && (
        <OptionsPanel
          value={color?.key}
          setValue={handleColorSelect}
          options={_.map(colorOptions, (color) => ({
            ...color,
            label: __('canvas.toolbar.color.' + color?.key),
          }))}
          customStyles={styles.optionsPanel}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    fabric_overlay: state.fabric_overlay,
  };
};

export default connect(mapStateToProps, null)(Color);
